












import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class VLoader extends Vue {
  @Prop()
  text!: string;
}
